export default [
  {
    category: 'SuperStar',
    name: 'yo',
    gitlab: 'https://gitlab.com/yo',
    merged_mrs: 340,
  },
  {
    category: 'SuperStar',
    name: 'Taukya Noguchi',
    gitlab: 'https://gitlab.com/tnir',
    merged_mrs: 311,
  },
  {
    category: 'SuperStar',
    name: 'Lee Tickett',
    gitlab: 'https://gitlab.com/leetickett',
    merged_mrs: 132,
  },
  {
    category: 'SuperStar',
    name: 'Marvin Karegyeya',
    gitlab: 'https://gitlab.com/nuwe1',
    merged_mrs: 126,
  },
  {
    category: 'SuperStar',
    name: 'Ben Bodenmiller',
    gitlab: 'https://gitlab.com/bbodenmiller',
    merged_mrs: 119,
  },
  {
    category: 'SuperStar',
    name: 'Niklas van Schrick',
    gitlab: 'https://gitlab.com/Taucher2003',
    merged_mrs: 117,
  },
  {
    category: 'SuperStar',
    name: 'Kev',
    gitlab: 'https://gitlab.com/KevSlashNull',
    merged_mrs: 109,
  },
  {
    category: 'SuperStar',
    name: 'feistel',
    gitlab: 'https://gitlab.com/feistel',
    merged_mrs: 100,
  },
  {
    category: 'SuperStar',
    name: 'Siddharth Asthana',
    gitlab: 'https://gitlab.com/edith007',
    merged_mrs: 98,
  },
  {
    category: 'SuperStar',
    name: 'Abdul Wadood',
    gitlab: 'https://gitlab.com/abdulwd',
    merged_mrs: 85,
  },
  {
    category: 'SuperStar',
    name: 'Jonston Chan',
    gitlab: 'https://gitlab.com/JonstonChan',
    merged_mrs: 84,
  },
  {
    category: 'SuperStar',
    name: 'huzaifaiftikhar1',
    gitlab: 'https://gitlab.com/huzaifaiftikhar',
    merged_mrs: 84,
  },
  {
    category: 'Star',
    name: 'Mathieu Parent',
    gitlab: 'https://gitlab.com/sathieu',
    merged_mrs: 75,
  },
  {
    category: 'Star',
    name: 'Jonas Wälter',
    gitlab: 'https://gitlab.com/wwwjon',
    merged_mrs: 60,
  },
  {
    category: 'Star',
    name: 'Andrew Smith (EspadaV8)',
    gitlab: 'https://gitlab.com/espadav8',
    merged_mrs: 31,
  },
  {
    category: 'Star',
    name: 'Baodong',
    gitlab: 'https://gitlab.com/icbd',
    merged_mrs: 31,
  },
  {
    category: 'Star',
    name: 'Mehul Sharma',
    gitlab: 'https://gitlab.com/mehulsharma',
    merged_mrs: 31,
  },
  {
    category: 'Star',
    name: 'Edmund Ochieng',
    gitlab: 'https://gitlab.com/ochienged',
    merged_mrs: 29,
  },
  {
    category: 'Star',
    name: 'Michael LeBeau',
    gitlab: 'https://gitlab.com/mlebeau',
    merged_mrs: 29,
  },
  {
    category: 'Star',
    name: 'Rishabh Gupta',
    gitlab: 'https://gitlab.com/imrishabh18',
    merged_mrs: 29,
  },
  {
    category: 'Star',
    name: 'Shreedhar Bhat',
    gitlab: 'https://gitlab.com/shridharbhat1998',
    merged_mrs: 29,
  },
  {
    category: 'Star',
    name: 'Abhijeet Chatterjee',
    gitlab: 'https://gitlab.com/abhijeet007rocks8',
    merged_mrs: 28,
  },
  {
    category: 'Star',
    name: 'Raimund Hook',
    gitlab: 'https://gitlab.com/stingrayza',
    merged_mrs: 27,
  },
  {
    category: 'Star',
    name: 'Shubham Kumar',
    gitlab: 'https://gitlab.com/imskr',
    merged_mrs: 27,
  },
  {
    category: 'Star',
    name: 'Matt Veitas',
    gitlab: 'https://gitlab.com/matt.veitas',
    merged_mrs: 24,
  },
  {
    category: 'Star',
    name: 'Winkie\'s',
    gitlab: 'https://gitlab.com/winkies',
    merged_mrs: 24,
  },
  {
    category: 'Star',
    name: 'Mike Russo',
    gitlab: 'https://gitlab.com/mikerusso',
    merged_mrs: 22,
  },
  {
    category: 'Star',
    name: 'Zhu Shuang',
    gitlab: 'https://gitlab.com/memorycancel',
    merged_mrs: 21,
  },
  {
    category: 'Star',
    name: 'JeremyWuuuuu',
    gitlab: 'https://gitlab.com/JeremyWuuuuu',
    merged_mrs: 20,
  },
  {
    category: 'Star',
    name: 'zhitong ren',
    gitlab: 'https://gitlab.com/orozot',
    merged_mrs: 19,
  },
  {
    category: 'Star',
    name: 'scootergrisen',
    gitlab: 'https://gitlab.com/scootergrisen',
    merged_mrs: 18,
  },
  {
    category: 'Star',
    name: 'Piotr Stankowski',
    gitlab: 'https://gitlab.com/trakos',
    merged_mrs: 16,
  },
  {
    category: 'Star',
    name: 'Daniel Schömer',
    gitlab: 'https://gitlab.com/quatauta',
    merged_mrs: 15,
  },
  {
    category: 'Star',
    name: 'yoginth.eth',
    gitlab: 'https://gitlab.com/yo',
    merged_mrs: 15,
  },
  {
    category: 'Star',
    name: 'Kun Qian',
    gitlab: 'https://gitlab.com/qk44077907',
    merged_mrs: 13,
  },
  {
    category: 'Star',
    name: 'Simon Stieger',
    gitlab: 'https://gitlab.com/sim0',
    merged_mrs: 12,
  },
  {
    category: 'Star',
    name: 'Harrison Healey',
    gitlab: 'https://gitlab.com/hmhealey',
    merged_mrs: 11,
  },
  {
    category: 'Star',
    name: 'Stefan Schmalzhaf',
    gitlab: 'https://gitlab.com/the_s',
    merged_mrs: 11,
  },
  {
    category: 'Enthusiast',
    name: 'Jörg Behrmann',
    gitlab: 'https://gitlab.com/behrmann',
    merged_mrs: 10,
  },
  {
    category: 'Enthusiast',
    name: 'Stanislav Lashmanov',
    gitlab: 'https://gitlab.com/cyberap',
    merged_mrs: 10,
  },
  {
    category: 'Enthusiast',
    name: 'Ercan Ucan',
    gitlab: 'https://gitlab.com/ercan.ucan',
    merged_mrs: 9,
  },
  {
    category: 'Enthusiast',
    name: 'Ethan Reesor',
    gitlab: 'https://gitlab.com/firelizzard',
    merged_mrs: 9,
  },
  {
    category: 'Enthusiast',
    name: 'Jean-Philippe Baconnais',
    gitlab: 'https://gitlab.com/jeanphi.baconnais',
    merged_mrs: 9,
  },
  {
    category: 'Enthusiast',
    name: 'Lucas Zampieri',
    gitlab: 'https://gitlab.com/lzampier',
    merged_mrs: 9,
  },
  {
    category: 'Enthusiast',
    name: 'Roger Meier',
    gitlab: 'https://gitlab.com/bufferoverflow',
    merged_mrs: 9,
  },
  {
    category: 'Enthusiast',
    name: 'vincent stchu',
    gitlab: 'https://gitlab.com/vincent_stchu',
    merged_mrs: 9,
  },
  {
    category: 'Enthusiast',
    name: 'Carlos Panato',
    gitlab: 'https://gitlab.com/cpanato',
    merged_mrs: 8,
  },
  {
    category: 'Enthusiast',
    name: 'George Tsiolis',
    gitlab: 'https://gitlab.com/gtsiolis',
    merged_mrs: 8,
  },
  {
    category: 'Enthusiast',
    name: 'Jim Cser',
    gitlab: 'https://gitlab.com/jimcser',
    merged_mrs: 8,
  },
  {
    category: 'Enthusiast',
    name: 'Mitar',
    gitlab: 'https://gitlab.com/mitar',
    merged_mrs: 8,
  },
  {
    category: 'Enthusiast',
    name: 'Adrián López Calvo',
    gitlab: 'https://gitlab.com/AdrianLC',
    merged_mrs: 7,
  },
  {
    category: 'Enthusiast',
    name: 'David Barr',
    gitlab: 'https://gitlab.com/davebarr',
    merged_mrs: 7,
  },
  {
    category: 'Enthusiast',
    name: 'Kolja Lucht',
    gitlab: 'https://gitlab.com/k0jak',
    merged_mrs: 7,
  },
  {
    category: 'Enthusiast',
    name: 'Manisha Singh',
    gitlab: 'https://gitlab.com/manisha270417',
    merged_mrs: 7,
  },
  {
    category: 'Enthusiast',
    name: 'Marshall Cottrell',
    gitlab: 'https://gitlab.com/marshall007',
    merged_mrs: 7,
  },
  {
    category: 'Enthusiast',
    name: 'Shuang Zhang',
    gitlab: 'https://gitlab.com/tonygodspeed92',
    merged_mrs: 7,
  },
  {
    category: 'Enthusiast',
    name: 'Wilson Barr',
    gitlab: 'https://gitlab.com/texbarr',
    merged_mrs: 7,
  },
  {
    category: 'Enthusiast',
    name: 'Alexander Kutelev',
    gitlab: 'https://gitlab.com/kutelev',
    merged_mrs: 6,
  },
  {
    category: 'Enthusiast',
    name: 'Linjie Zhang',
    gitlab: 'https://gitlab.com/zhanglinjie',
    merged_mrs: 6,
  },
  {
    category: 'Enthusiast',
    name: 'Oghenerukevwe Kofi',
    gitlab: 'https://gitlab.com/rukkykofi',
    merged_mrs: 6,
  },
  {
    category: 'Enthusiast',
    name: 'Philipp Böschen',
    gitlab: 'https://gitlab.com/Deichindianer',
    merged_mrs: 6,
  },
  {
    category: 'Enthusiast',
    name: 'Roman Pertl',
    gitlab: 'https://gitlab.com/roman_pertl',
    merged_mrs: 6,
  },
  {
    category: 'Enthusiast',
    name: 'blanet',
    gitlab: 'https://gitlab.com/blanet',
    merged_mrs: 6,
  },
  {
    category: 'Enthusiast',
    name: 'dave liu',
    gitlab: 'https://gitlab.com/daveliu',
    merged_mrs: 6,
  },
  {
    category: 'Enthusiast',
    name: 'Anshuman Singh',
    gitlab: 'https://gitlab.com/singhanshuman',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Avinash Upadhyaya',
    gitlab: 'https://gitlab.com/avinashupadhya99',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Cong Chen',
    gitlab: 'https://gitlab.com/genctys',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Cyrine Gamoudi',
    gitlab: 'https://gitlab.com/CyrineG1',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Daniel Ziegenberg',
    gitlab: 'https://gitlab.com/ziegenberg',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Diego Louzán',
    gitlab: 'https://gitlab.com/dlouzan',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Guillaume Chauvel',
    gitlab: 'https://gitlab.com/guillaume.chauvel',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Hannes Rosenögger',
    gitlab: 'https://gitlab.com/haynes',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Jan',
    gitlab: 'https://gitlab.com/kingjan1999',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Kyle Edwards',
    gitlab: 'https://gitlab.com/KyleFromKitware',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Leni Kadali Mutungi',
    gitlab: 'https://gitlab.com/lenikadali',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Marcel Amirault',
    gitlab: 'https://gitlab.com/marcel.amirault',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Matthias Fechner',
    gitlab: 'https://gitlab.com/mfechner',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Pirate Praveen',
    gitlab: 'https://gitlab.com/pravi',
    merged_mrs: 5,
  },
];
